module.exports = __webpack_public_path__ + "static/img/pinpaidongtai.6a6ddd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/pinpaidongtai.png
// module id = MhLJ
// module chunks = 1